import { TrendingUp } from "lucide-react";
import { T } from "../theme";
import { Eyebrow, Card, Pill } from "../components";

/** ESTIMATES — design reference (P2 estimation engine). Gut vs. measured. */
export function Estimates() {
  const cats = [
    { name: "Fabrication", coef: 1.85, n: 14, you: 60, real: 111 },
    { name: "Errands", coef: 2.1, n: 9, you: 30, real: 63 },
    { name: "Admin / comms", coef: 1.2, n: 22, you: 25, real: 30 },
    { name: "Event prep", coef: 1.45, n: 7, you: 90, real: 130 },
  ];
  return (
    <div style={{ padding: "18px 16px 24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Eyebrow>estimation engine</Eyebrow>
        <Pill color={T.gold} bg="rgba(255,180,84,.12)">
          <TrendingUp size={9} style={{ verticalAlign: "-1px" }} /> learning
        </Pill>
      </div>

      <div style={{ margin: "16px 0 4px", fontSize: 20, color: T.paper, fontWeight: 650 }}>Gut feel, measured.</div>
      <div style={{ fontSize: 12, color: T.mist, marginBottom: 16, lineHeight: 1.5 }}>Plans use the learned number. No lectures — just the gap.</div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {cats.map((c) => (
          <Card key={c.name} style={{ padding: "12px 13px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
              <span style={{ fontSize: 13.5, color: T.paper, fontWeight: 600 }}>{c.name}</span>
              <span className="mono" style={{ fontSize: 15, color: c.coef > 1.7 ? T.dawn : c.coef > 1.3 ? T.gold : T.mint, fontWeight: 600 }}>×{c.coef.toFixed(2)}</span>
            </div>
            <div style={{ marginTop: 9 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span className="mono" style={{ fontSize: 9, color: T.dim, width: 30 }}>GUT</span>
                <div style={{ height: 6, borderRadius: 3, background: T.mist, width: `${(c.you / c.real) * 62}%`, opacity: 0.55 }} />
                <span className="mono" style={{ fontSize: 9.5, color: T.dim }}>{c.you}m</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                <span className="mono" style={{ fontSize: 9, color: T.dim, width: 30 }}>REAL</span>
                <div style={{ height: 6, borderRadius: 3, background: `linear-gradient(90deg, ${T.gold}, ${T.dawn})`, width: "62%" }} />
                <span className="mono" style={{ fontSize: 9.5, color: T.gold }}>{c.real}m</span>
              </div>
            </div>
            <div className="mono" style={{ fontSize: 9, color: T.dim, marginTop: 7 }}>{c.n} samples · typical task shown</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
